import React from "react";
import logo from "../../images/logo-2.svg";


const Logo = () => {
  return <img src={logo} alt="logo" width="30" height="30" />
}

export default Logo